import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDT } from "@/lib/constants";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit-logs").then((r) => setRows(r.data)); }, []);
  return (
    <div className="space-y-5">
      <div><h1 className="font-display text-2xl font-bold text-[#151515]">Security audit log</h1><p className="text-sm text-neutral-500">Immutable record of logins, modifications, re-assignments and exports.</p></div>
      <div className="overflow-x-auto rounded-2xl border border-neutral-200">
        <table className="w-full text-xs" data-testid="audit-table">
          <thead className="bg-white"><tr className="text-left font-mono text-neutral-400"><th className="px-3 py-2">When</th><th>Actor</th><th>Action</th><th>Entity</th><th>Details</th></tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.id} className="border-t border-neutral-200 text-neutral-600"><td className="whitespace-nowrap px-3 py-2 font-mono">{fmtDT(r.at)}</td><td>{r.actor_name}</td><td className="font-mono text-[#1F9E7A]">{r.action}</td><td className="font-mono text-neutral-400">{r.entity}:{String(r.entity_id).slice(0, 8)}</td>
              <td className="max-w-xs truncate text-neutral-500">{Object.entries(r.details).map(([k, v]) => `${k}=${v}`).join(" · ")}</td></tr>))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
